<div
  class="autocomplete-item"
  [class.autocomplete-item--disabled]="disabled()"
  [attr.aria-disabled]="disabled() || null"
  (click)="onItemClick()"
>
  <span class="autocomplete-item__template">
    <span class="autocomplete-item__prefix empty-hidden">
      <ng-content select="[prefix]"></ng-content>
    </span>
    <span class="autocomplete-item__content">
      <span class="autocomplete-item__label empty-hidden text-ellipsis">
        <ng-content select="[label]"></ng-content>
      </span>
      <span class="autocomplete-item__description empty-hidden text-ellipsis">
        <ng-content select="[description]"></ng-content>
      </span>
    </span>
    <span class="autocomplete-item__postfix empty-hidden">
      <ng-content select="[postfix]"></ng-content>
    </span>
  </span>
  <ng-content></ng-content>
</div>
